package team.platforma.module_network.di

import io.ktor.client.HttpClient
import org.koin.dsl.bind
import org.koin.dsl.module
import team.platforma.module_network.client.MainClient

val networkModule = module {
    single {
        MainClient().build()
    }.bind<HttpClient>()
}